import { listMessages, searchMessages } from '../../services/searchmessages'

// Adapts the searchroom message service to the generic chat-engine `api` shape
// (listPage/search). A future messages page would provide its own adapter with
// the same interface to reuse useChatTranscript / useMessageSearch.
export function makeSearchroomChatApi(searchroomId) {
  return {
    listPage: (opts) => listMessages(searchroomId, opts),
    search: ({ q, limit }) => searchMessages(searchroomId, q, limit),
  }
}
